import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../../lib/firebase";
import { Loader2 } from "lucide-react";

export default function LineCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const handleCallback = async () => {
      const token = searchParams.get("token");
      const errorParam = searchParams.get("error");
      const errorMessage = searchParams.get("message");

      if (errorParam) {
        setError(errorMessage || "เกิดข้อผิดพลาดในการเข้าสู่ระบบด้วย LINE");
        setTimeout(() => {
          navigate("/");
        }, 3000);
        return;
      }

      if (!token) {
        setError("ไม่พบ token สำหรับการเข้าสู่ระบบ");
        setTimeout(() => {
          navigate("/");
        }, 3000);
        return;
      }

      try {
        await signInWithCustomToken(auth, token);
        
        const returnUrl = sessionStorage.getItem("returnUrl") || "/";
        sessionStorage.removeItem("returnUrl");
        
        navigate(returnUrl);
      } catch (err: any) {
        console.error("LINE login error:", err);
        setError("ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่อีกครั้ง");
        setTimeout(() => {
          navigate("/");
        }, 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-blue-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-full text-center">
        {error ? (
          <>
            <div className="w-16 h-16 rounded-full bg-red-100 mx-auto mb-4 flex items-center justify-center">
              <span className="text-3xl">❌</span>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">เกิดข้อผิดพลาด</h2>
            <p className="text-red-600 mb-4">{error}</p>
            <p className="text-gray-600 text-sm">กำลังนำคุณกลับไปหน้าหลัก...</p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 rounded-full bg-green-100 mx-auto mb-4 flex items-center justify-center">
              <Loader2 className="w-8 h-8 text-green-600 animate-spin" />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">กำลังเข้าสู่ระบบ</h2>
            <p className="text-gray-600">กรุณารอสักครู่...</p>
          </>
        )}
      </div>
    </div>
  );
}
